import React, { Suspense, lazy } from 'react'
import Pages from './Pages'
import NebulaPages from './NebulaPages'
import VerifyLogin from './NebulaPages/VerifyLogin'
import KYC from './KYC'
import { Route, BrowserRouter, Routes } from 'react-router-dom'
const Root = lazy(() => import('./Root'))
const NebulaRoot = lazy(() => import('./NebulaRoot'))
const VerifyLoginRoot = lazy(() => import('./verifyLoginRoot'))

// prettier-ignore
export default function App () {
  return (
    <BrowserRouter onUpdate={() => window.scrollTo(0, 0)} key={Math.random()}>
      <Routes>
        <Route element={<Suspense><Root /></Suspense>}>{Pages}</Route>
        <Route element={<Suspense><NebulaRoot /></Suspense>}>{NebulaPages}</Route>
        <Route element={<Suspense><NebulaRoot /></Suspense>}>{KYC}</Route>
        <Route element={<Suspense><VerifyLoginRoot /></Suspense>}>{VerifyLogin}</Route>
      </Routes>
    </BrowserRouter>
  )
}
